export default function (vehicleId, keeperId, close, getKeeperDetails, updateKeeperDetails, toaster, vehicleSourced) {
    const vm = this;

    vm.details = {};
    vm.vehicleSourced = [];

    /* --- */

    vm.closeModal = closeModal;
    vm.update = updateKeeper;

    /* --- */

    getKeeperDetails(vehicleId, keeperId)
    .then(details => {
        vm.details = details;
    });

    vehicleSourced.then(s => {
        vm.vehicleSourced = s;
    });

    /* --- */

    function closeModal() {
        close();
    }

    function updateKeeper() {
        updateKeeperDetails(vehicleId, keeperId, vm.details)
            .then(() => {
                toaster.success('Keeper have been updated');
                close();
            });
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/keepers/details/keeperDetailsCtrl.js